import {EventEmitter, Injectable} from '@angular/core';
import {Observable, ReplaySubject} from 'rxjs';
import {UserDomain} from './user-domain';
import {AuthService, ConfigService} from 'shared';
import {HttpClient} from '@angular/common/http';
import {map, tap} from 'rxjs/operators';
import {WebsocketService} from '../services/websocket/websocket.service';

@Injectable({
  providedIn: 'root'
})
export class UserDomainService {

  public domains: UserDomain[] = [];
  private selected: UserDomain;
  domainChanged = new ReplaySubject<UserDomain | null>();

  constructor(
    private http: HttpClient,
    private config: ConfigService,
    private authService: AuthService,
  ) {
    authService.loginChanged.subscribe(loggedIn => {
      if (!loggedIn) {
        this.reset();
      }
    });
    /*    setTimeout(() => {
          this.selectDomain(this.domains[1]);
        }, 10000);
        setTimeout(() => {
          this.selectDomain(this.domains[0]);
        }, 20000);
        setTimeout(() => {
          this.selectDomain();
        }, 30000);*/
  }

  public userDomains(): Observable<UserDomain[]> {
    return this.http.get<UserDomain[]>(this.config.apiVerUrl('/app/domains/user-domains')).pipe(
      map(r => {
        this.domains = r.map<UserDomain>((i) => new UserDomain(i));
        return this.domains;
      }),
      tap(_ => {
        this.domainChanged.next(this.selectedDomain());
      })
    );
  }

  public userDomainsWithAreas(): Observable<UserDomain[]> {
    return this.http.get<UserDomain[]>(this.config.apiVerUrl('/app/domains/user-domains-with-areas')).pipe(
      map(r => {
        this.domains = r.map<UserDomain>((i) => new UserDomain(i));
        return this.domains;
      }),
      tap(_ => {
        this.domainChanged.next(this.selectedDomain());
      })
    );
  }

  private storeSelectedInStorage() {
    if (this.selected != null) {
      localStorage.setItem('domain', JSON.stringify(this.selected));
    } else {
      localStorage.removeItem('domain');
    }
  }

  private getSelectedFromStorage(): UserDomain | null {
    const json = localStorage.getItem('domain');
    if (json === null) {
      return null;
    }
    const domain = JSON.parse(json);
    return this.selected = this.domains.find((d) => domain.id === d.id);
  }

  private firstIfSingleDomain(): UserDomain | null {
    return this.selected = (this.hasSingleDomain() ? this.domains[0] : null);
  }

  public selectDomain(domain?: UserDomain) {
    this.selected = domain;
    this.storeSelectedInStorage();
    this.domainChanged.next(this.selected);
  }

  public selectedDomain(): UserDomain | null {
    return this.selected || this.getSelectedFromStorage() || this.firstIfSingleDomain();
  }

  public hasSingleDomain(): boolean {
    return this.domains.length === 1;
  }

  public reset() {
    this.selected = null;
    this.domains = [];
    localStorage.removeItem('domain');
  }
}
